import React from 'react';

import { Inject } from '@odinjs/odin';

import { Endpoint, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { FetchAPI, Link, PanelAPI } from '@philips-emr/tws-components';
import { Size } from '@philips-emr/tws-constants';
import Controller, { OnCancel, OnClose, OnDynamicContentRender, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import { NegotiationMaterialsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { Item } from './negotiation-procedures-controller';

const MATERIAL = 'M';

@Controller({ fragment: FragmentNames.NEGOTIATION_MATERIALS })
class NegotiationMaterialsController extends BaseController {

  @Inject(Aliases.FETCH_MATERIALS)
  private fetchMaterials: FetchAPI;
  @Inject(Aliases.PANEL_MODAL_MATERIAL)
  private panelModal: PanelAPI;

  @OnMount(Aliases.FETCH_MATERIALS)
  onMountFetch(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqProposal, nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqNegotiation, nrSeqProposal, 'itemType': MATERIAL });
    api.setParameters({ nrSeqNegotiation, nrSeqProposal, 'itemType': MATERIAL });
    api.forceFetch();
  }

  @OnMount(Aliases.FETCH_MATERIAL)
  onMountFetchMaterial(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqProposal, nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    const { nrSeqItemProposal } = this.context.getBulkData();
    api.setParameters({ nrSeqNegotiation, nrSeqProposal, 'itemType': MATERIAL, nrSeqItemProposal });
    api.forceFetch();
  }

  @OnDynamicContentRender(Aliases.CARD_MATERIAL)
  onRenderLinkEdit(event: RenderEvent): void {
    const { render, data } = event;
    const { edit, nrSeqItemProposal } = data as Item;

    if (edit == 'S') {
      render(() =>
        <Link onClick={() => this.onOpenEditProposal(nrSeqItemProposal)} value={MessageService.translate('pa.change-value')}
          size={Size.MEDIUM} />
      );
    }
  }

  @OnSubmit(Aliases.FORM_MATERIAL)
  onSubmitMaterial(event: SubmitEvent): void {
    const body = { ...event.record, 'itemType': MATERIAL };
    const { nrSeqProposal, nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.EDIT_NEGOTIATION_PROPOSAL_ITEM, { nrSeqProposal, nrSeqNegotiation }, { body })
      .then(() => {
        this.fetchMaterials.forceFetch();
        this.panelModal.setVisible(false);
        ToastServiceProviderAccreditation.successBubble(MessageService.translate('pa.request-success'));
      }).catch(() => {
        ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request'));
      });
  }

  @OnClose(Aliases.MODAL_MATERIAL)
  onCloseModal(): void {
    this.panelModal.setVisible(false);
  }

  @OnCancel(Aliases.FORM_MATERIAL)
  onCancelCounterOffer(): void {
    this.panelModal.setVisible(false);
  }

  onOpenEditProposal(nrSeqItemProposal: number): void {
    this.context.set({ nrSeqItemProposal });
    this.panelModal.setVisible(true);
  }

}

export default NegotiationMaterialsController;
